// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"2438f2d6","703":"35c0c9c9"}[chunkId] + ".chunk.js";
};